import { apiKeysToFilterKeys, filterConstants } from './constants';
import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions/';
import { message } from 'antd';

export const filterActions = {
  save,  
  deleteFilter,
  getList,
	retrieveLastState,
	setFilterChanged,
}

function getList() {
  const url = '/Filter/filters';
  return (dispatch) => {
    const apiRequest = client.get(url, { headers: authHeader() });
    dispatch({
      type: filterConstants.GET_SAVED_FILTERS_LIST,
      payload: apiRequest,
    });
    return apiRequest;
  };
}

function deleteFilter({id}) {
	const url = `/Filter?id=${id}`
  return async (dispatch) => {
    dispatch({
			type: filterConstants.DELETE_FILTER,
			payload: await client.delete(url, { headers: authHeader() })
		})	
  }
}

const isAllTimeRange = (dateRange) => {
  if (!dateRange || !dateRange[0]) return false;
  const startDate = dateRange[0];
  if (!startDate || typeof startDate.year !== 'function') return false;
  const startYear = startDate.year();
  return startYear < 1500;
};

const createFilter = (filterStore) =>
  Object.entries(apiKeysToFilterKeys).reduce(
    (acc, { 0: apiKey, 1: filterKey }) => {
      acc[apiKey] = filterStore[filterKey];
      return acc;
    },
    {}
  );

function save({name}) {
	const url = `/Filter`

  if(!name || name.length === 0 || /^\s*$/.test(name)) return

  return async (dispatch, getState) => {
		const filterStore = getState().filterStore;

    const serviceCompanyFilter = getState().authentication.userInfo.ServiceCompanyFilter

		if (isAllTimeRange(filterStore.dateRange) && (!filterStore.valueCompany || filterStore.valueCompany.length === 0) && serviceCompanyFilter) {
			message.error('При выборе диапазона "Все время" необходимо выбрать УК');
			return;
		}

		const filter = createFilter(filterStore);

		const replace = filterStore.savedList.find(e=>e.name===name)

    const data = {
			Id: replace ? replace.id : null,
      Name: name,
      Filter: JSON.stringify(filter),
    }

    await dispatch({
			type: filterConstants.SAVE_FILTER,
			payload: replace ? client.put(url, data, { headers: authHeader() })
				: client.post(url, data, { headers: authHeader() })
		})
		dispatch(getList())
	}
}

function retrieveLastState(state) {
	return dispatch => {
		dispatch({
			type: filterConstants.RETRIEVE_LAST_STATE,
			payload: state
		})
	}
}

function setFilterChanged(changed) {
  return {
    type: filterConstants.SET_FILTER_CHANGED,
    payload: changed,
  };
}
